import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import styled from 'foundations-theming/utils';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { CardMenuChangePlaylistThumbnailOption, MobileMenuChangePlaylistThumbnailOption } from '../../../features/savedItems/components/CardMenuChangePlaylistThumbnailOption';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import MobileNestedMenu from '../../Modals/FullScreenModal/MobileNestedMenu';
import { useCanUserEditPlaylist } from '../../../features/savedItems/savedItemsHooks';
import { UploadPlaylistThumbnailButton } from '../../../features/savedItems/components/UploadPlaylistThumbnailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Obscurer = styled.div.withConfig({
  displayName: "PlaylistThumbnailBlank__Obscurer",
  componentId: "sc-19ufqx9-0"
})(["height:100%;width:100%;transition:0.3s ease background;padding:0 20%;& > *{opacity:0;}a{", " text-decoration:none;&:hover{text-decoration:underline;}}", ";"], ({
  theme,
  $isActive
}) => !$isActive && `color: ${theme.color['text-core-on-fill-default']} !important;`, ({
  theme,
  $isActive
}) => $isActive ? `
      background-color: ${theme.color['fill-primary-disabled']};
      & > * {
        opacity: 1;
      }
      ` : `
      &:hover,
      &.menu-open {
        background-color: rgba(0, 0, 0, 0.65);
        & > * {
          opacity: 1;
        }
      }
      `);
const PlaylistThumbnailBlankChangeButton = ({
  hasThumbnail,
  onClick,
  use = 'blue'
}) => /*#__PURE__*/_jsxs(Link, {
  onClick: onClick,
  use: use,
  children: [/*#__PURE__*/_jsx(IconHolder, {
    icon: hasThumbnail ? EditIcon : AddIcon
  }), hasThumbnail ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.playlistDetails.thumbnailBlankChangeThumbnail"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.playlistDetails.thumbnailBlankChooseThumbnail"
  })]
});
const PlaylistThumbnailBlank = ({
  onAddContent,
  playlist
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    isMobile
  } = useMediaQuery();
  const canUserEditPlaylist = useCanUserEditPlaylist(playlist.id);
  if (!canUserEditPlaylist) {
    return null;
  }
  if (!playlist.itemsCount && !playlist.thumbnailRectangleUrl) {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(Obscurer, {
        $isActive: true,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          blockSize: "100%",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(Text, {
            color: "text-tertiary-default",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "learningCenter.savedItems.playlistDetails.thumbnailBlankNoItems",
              options: {
                addThumbnailAction: /*#__PURE__*/_jsx(UploadPlaylistThumbnailButton, {
                  playlistId: playlist.id,
                  use: "link"
                }),
                addContentAction: /*#__PURE__*/_jsx(Link, {
                  onClick: onAddContent,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "learningCenter.savedItems.playlistDetails.thumbnailBlankAddContent"
                  })
                })
              }
            })
          })
        })
      })
    );
  }
  if (isMobile) {
    if (playlist.thumbnailRectangleUrl) {
      return null;
    }
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(Obscurer, {
        $isActive: true,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          blockSize: "100%",
          justifyContent: "center",
          padding: "500",
          children: [/*#__PURE__*/_jsx(PlaylistThumbnailBlankChangeButton, {
            hasThumbnail: !!playlist.thumbnailRectangleUrl,
            onClick: () => setIsMenuOpen(true),
            use: "blue"
          }), isMenuOpen && /*#__PURE__*/_jsx(MobileNestedMenu, {
            indented: false,
            open: true,
            setIsOpen: openState => setIsMenuOpen(openState),
            useBackText: true,
            useSidePanel: true,
            children: /*#__PURE__*/_jsx(MobileMenuChangePlaylistThumbnailOption, {
              onItemClick: () => setIsMenuOpen(false),
              playlistId: playlist.id
            })
          })]
        })
      })
    );
  }
  const isObscurerActive = !playlist.thumbnailRectangleUrl;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Obscurer, {
      $isActive: isObscurerActive,
      className: isMenuOpen ? 'menu-open' : '',
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        blockSize: "100%",
        justifyContent: "center",
        padding: "500",
        children: /*#__PURE__*/_jsx(CardMenuChangePlaylistThumbnailOption, {
          onOpenChange: isOpen => setIsMenuOpen(isOpen),
          playlistId: playlist.id,
          render: handleClick => /*#__PURE__*/_jsx(PlaylistThumbnailBlankChangeButton, {
            hasThumbnail: !!playlist.thumbnailRectangleUrl,
            onClick: handleClick,
            use: isObscurerActive ? 'blue' : 'on-dark'
          })
        })
      })
    })
  );
};
export default PlaylistThumbnailBlank;